import { Application } from '../../types/Application';
import { ACCESS_ANALYSIS_BASE_URL } from '../consts';
import { ApplicationFilters } from '../../types/ApplicationFilters';
import { useFetchWithOffsetPagination } from '../base/useFetchWithOffsetPagination';

export type ApplicationDto = {
    app_id: string;
    business_criticality?: string;
    description?: string;
    last_access: string;
    name: string;
    ref_type?: string;
    total_identities: number;
    total_resources: number;
};

const mapResponse = (application: ApplicationDto): Application => ({
    ...application,
    last_access: application.last_access ? new Date(application.last_access) : undefined
});

export const useGetApplications = (
    filters: ApplicationFilters,
    sorting: { direction: 'asc' | 'desc'; field: string }
) => {
    const { data, fetchNextPage, loading, refresh } = useFetchWithOffsetPagination<
        ApplicationDto,
        Application,
        ApplicationFilters
    >({
        url: `${ACCESS_ANALYSIS_BASE_URL}/applications`,
        filters,
        sorting,
        mapResponse,
    });

    return {
        applications: data,
        applicationsLoading: loading,
        fetchMoreApplications: fetchNextPage,
        refetchApplications: refresh
    };
};
